// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"ffaeec56","801":"a680412f","848":"85416a00","895":"51c65add"}[chunkId] + ".css";
};